import { authInstanceMaster } from 'api/axios.config'
import { UserOrganizationsResponseType } from './types/response'

export class MasterUserApi {
  static getUserOrganizations = async () =>
    await authInstanceMaster.get<UserOrganizationsResponseType>('/authorization/switchOrganization')
}
